import React from "react";
import { Box, Typography } from "@mui/material";
import type { AsyncRoleplaySessionStatusLabel } from "./async-roleplay-session-panel";
import {
  metaRootStyles,
  panelBodyCompactStyles,
  panelBodyStyles,
  panelMetaItemStyles,
  panelMetaRowStyles,
  panelSectionStyles,
  panelStatusStyles,
  panelTitleStyles,
} from "./styles";

interface AsyncRoleplaySessionMetaProps {
  objective: string;
  status: AsyncRoleplaySessionStatusLabel;
  domain?: string | null;
  focusDisplayName?: string | null;
  timeBudgetLabel?: string | null;
}

const statusColor = (status: AsyncRoleplaySessionStatusLabel): string => {
  switch (status) {
    case "Ready":
      return "#22C55E";
    case "Recording":
    case "Uploading":
    case "Processing":
    case "Transcribing":
    case "Finishing":
      return "#7B49C1";
    case "Time limit":
    case "Report failed":
      return "#EF4444";
    case "Finished":
      return "#64748B";
    default:
      return "#64748B";
  }
};

export const AsyncRoleplaySessionMeta: React.FC<
  AsyncRoleplaySessionMetaProps
> = ({ objective, status, domain, focusDisplayName, timeBudgetLabel }) => {
  const focusLine =
    [domain, focusDisplayName].filter(Boolean).join(" · ") || null;

  return (
    <Box sx={metaRootStyles} aria-label="Session details">
      <Box sx={panelSectionStyles}>
        <Typography sx={panelTitleStyles}>Your Objective</Typography>
        <Typography sx={panelBodyCompactStyles}>{objective}</Typography>
      </Box>

      <Box sx={panelMetaRowStyles}>
        {focusLine && (
          <Box sx={panelMetaItemStyles}>
            <Typography sx={panelTitleStyles}>Focus</Typography>
            <Typography sx={panelBodyStyles}>{focusLine}</Typography>
          </Box>
        )}

        <Box sx={panelMetaItemStyles}>
          <Typography sx={panelTitleStyles}>Session Status</Typography>
          <Typography sx={panelStatusStyles(statusColor(status))}>
            {status}
          </Typography>
          {timeBudgetLabel ? (
            <Typography variant="caption" color="text.secondary">
              {timeBudgetLabel}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};
